<template>
  <div>
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">留言列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">留言</li>
              <li class="breadcrumb-item active">留言列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-comment" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-12">
            <div class="b-filter">
              <el-select v-model="filterParams.SGL_IsShow">
                <el-option label="已隱藏" :value="false"></el-option>
                <el-option label="未隱藏" :value="true"></el-option>
              </el-select>
              <el-button
                type="info"
                :class="{ current: -1 == filterParams.categoryId }"
                @click="selectByType($event, -1)"
                >全部</el-button
              >
              <el-button
                type="info"
                @click="selectByType($event, 0)"
                :class="{ current: 0 == filterParams.categoryId }"
                >相簿留言</el-button
              >
              <el-button
                type="info"
                @click="selectByType($event, 5)"
                :class="{ current: 5 == filterParams.categoryId }"
                >影音留言</el-button
              >
              <el-button
                type="info"
                @click="selectByType($event, 3)"
                :class="{ current: 3 == filterParams.categoryId }"
                >活動留言</el-button
              >
              <el-button
                type="info"
                @click="selectByType($event, 2)"
                :class="{ current: 2 == filterParams.categoryId }"
                >話題留言</el-button
              >
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table :data="commentList" border>
                  <el-table-column
                    label="留言內容"
                    prop="sgL_Msg_MContent"
                  ></el-table-column>
                  <el-table-column label="用戶">
                    <template slot-scope="scoped">
                      <span class="b-user-icon mr-1">
                        <img
                          :src="scoped.row.sgL_ImageLogin"
                          class="user-image img-circle"
                          alt="User Image"
                        />
                      </span>
                      <span class="b-username">
                        <a href="" target="_blank">
                          {{ scoped.row.sgL_Mem_DisplayName }}
                        </a>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="版塊"
                    prop="sgL_Msg_TypeF"
                  ></el-table-column>
                  <el-table-column
                    label="操作人"
                    prop="sgL_UpdateName"
                  ></el-table-column>
                  <el-table-column
                    label="備注"
                    prop="sgL_Remark"
                  ></el-table-column>
                  <el-table-column
                    label="隱藏時間"
                    prop="sgL_UpdateTimeF"
                  ></el-table-column>
                  <el-table-column
                    label="留言時間"
                    prop="sgL_Msg_MAddTimerF"
                  ></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scoped">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="tourl(scoped.row.clickUrl)"
                        >查看</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        v-if="scoped.row.sgL_IsShow == true"
                        @click="open(scoped.row.id, false)"
                        >隱藏</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        v-else
                        @click="open(scoped.row.id, true)"
                        >取消隱藏</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
              <div class="row">
                <div class="col-lg-4 offset-lg-7">
                  <!--  引用分页组件 -->
                  <pagination
                    v-if="pageParams.pageshow"
                    :currentPage="pageParams.currentPage"
                    :total="pageParams.total"
                    :limit="pageParams.limit"
                    :small="true"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import pagination from "../common/Page";
export default {
  data() {
    return {
      commentList: null,
      filterParams: {
        categoryId: -1,
        SGL_IsShow: false,
      },
      //分页参数
      pageParams: {
        currentPage: 1,
        limit: 10,
        total: 0,
        pageshow: true,
      },
    };
  },
  watch: {
    "filterParams.SGL_IsShow": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
        }
      },
    },
  },
  components: {
    pagination,
  },
  created() {
    this.GetCommentAll();
  },
  methods: {
    GetCommentAll() {
      let params = {
        Type: this.filterParams.categoryId,
        SGL_IsShow: this.filterParams.SGL_IsShow,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      this.$api.permissionApi.getCommentAll(params).then((res) => {
        if (res.data.success) {
          this.commentList = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
        }
      });
    },

    updateComment(id, remark) {
      let params = {
        sgL_Remark: remark,
        id: id,
      };
      this.$api.permissionApi.updateComment(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.handleCurrentChange(1);
        }
      });
    },
    open(id, n) {
      let msg = "留言隱藏後，所有人皆無法看到該留言。";
      if (n) {
        msg = "留言顯示後，所有人皆可看到該留言。";
      }
      this.$prompt("請輸入備注", msg, {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.updateComment(id, value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "操作取消",
          });
        });
    },
    tourl(url) {
      window.location.href = url;
    },
    //根据分类查询数据
    selectByType(e, index) {
      this.filterParams.categoryId = index;
      this.handleCurrentChange(1);
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.GetCommentAll();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetCommentAll();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminComment/comment.vue